// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetCustomerPackageDetailsResponse

import { hydrateCustomerPackage, type CustomerPackage, type CustomerPackageApiResponse } from './customerPackage.gen';
import { hydratePackage, type Package, type PackageApiResponse } from './package.gen';

export type WidgetCustomerPackageDetailsApiResponse = {
	customer_package: CustomerPackageApiResponse;
	package: PackageApiResponse | null;
};

export type WidgetCustomerPackageDetails = {
	customer_package: CustomerPackage;
	package: Package | null;
};

export function hydrateWidgetCustomerPackageDetails(data: WidgetCustomerPackageDetailsApiResponse): WidgetCustomerPackageDetails {
	return {
		...data,
		customer_package: hydrateCustomerPackage(data.customer_package),
		package: data.package ? hydratePackage(data.package) : null,
	};
}